 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }import styled from '@emotion/styled'
import React, {forwardRef} from 'react'
import defaultUserAvatar from '../../styles/theme/images/avatar-user.svg'
import AvatarBadge from '../AvatarBadge/AvatarBadge'



const ImageBlock = styled('div')(
  ({sansRadius, sansShadow, picture, size, onClick}) => ({
    backgroundImage: `url(${_nullishCoalesce(picture, () => ( defaultUserAvatar))})`,
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    borderRadius: sansRadius ? 0 : '100%',
    boxShadow: sansShadow ? 'none' : undefined,
    cursor: onClick ? 'pointer' : 'default',
    display: 'block',
    flexShrink: 0,
    width: size,
    height: size
  })
)

const BadgeBlock = styled('div')({
  alignItems: 'center',
  display: 'flex',
  height: '25%',
  justifyContent: 'center',
  position: 'absolute',
  right: 0,
  top: 0,
  width: '25%'
})

const BadgeBlockInner = styled('div')({
  flexShrink: 0
})














const Avatar = forwardRef((props, ref) => {
  const {
    className,
    hasBadge,
    isConnected,
    onClick,
    onMouseEnter,
    onTransitionEnd,
    picture,
    sansRadius,
    sansShadow,
    size
  } = props

  return (
    React.createElement(ImageBlock, {
      onTransitionEnd: onTransitionEnd,
      className: className,
      ref: ref,
      onClick: onClick,
      onMouseEnter: onMouseEnter,
      sansRadius: sansRadius,
      sansShadow: sansShadow,
      picture: picture,
      size: size,}

      , hasBadge && (
        React.createElement(BadgeBlock, null
          , React.createElement(BadgeBlockInner, null
            , React.createElement(AvatarBadge, { isConnected: isConnected || false,} )
          )
        )
      )
    )
  )
})

export default Avatar
